export default "__VITE_ASSET__DUIbsMMz__"